import { DEFAULT_LOCATIONS, TARGET, DROPDOWN } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token a8b6f581e527aecac2ddf6384e893c9f1ba2ced4',
  staging: 'Token 26c189fb46a8a13ede33ecef9fe7ec1c983cd4a5',
  prod: 'Token 91ee4ec9fb126692d50d29854233dae588b38140',
};

const token = selectToken(apiTokens);

const targetConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'target',

  API_TOKEN: token,
  EMBOLD_CLIENT: TARGET,

  // login
  SHOW_REGION_SELECTOR: true,
  NETWORKS: {},

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.Minneapolis },
  LOGIN_NETWORK_NAME: 'targetUserId',

  // content
  DISPLAY_NAME: 'Target',
  FORM_VARIANT: DROPDOWN,
  NO_WELCOME_LINK: false,
};

export default targetConfig;
